import PopupRedirectToForm101 from './PopupRedirectToForm101';

export default PopupRedirectToForm101;
